import { createFileRoute } from "@tanstack/react-router";

import { ClosingBand } from "@/features/portal/components/closing-band";
import { PortalHead, PortalPage } from "@/features/portal/components/portal-chrome";
import {
  PricingCards,
  PricingHero,
  PricingHow,
  PricingQuestions,
} from "@/features/portal/modules/pricing-page/pricing-page";
import { pageMeta } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/pricing/")({
  head: () => ({ meta: pageMeta({ title: m.portal_nav_pricing(), description: m.seo_pricing_description() }) }),
  loader: () => ({ crumb: m.portal_nav_pricing() }),
  component: PricingPage,
});

/** What it costs: the app, which is free, the visits, which each specialist prices, and how paying works. */
function PricingPage() {
  return (
    <PortalPage
      head={
        <PortalHead>
          <PricingHero />
        </PortalHead>
      }
    >
      <PricingCards />
      <PricingHow />
      <PricingQuestions />
      <ClosingBand />
    </PortalPage>
  );
}
